export default {
  roles: [],
  data: [],
  detail:{},
  total: {
    totalItems: 5,
    totalPages: 5,
  },

};
